export type ReferralModalMode = "add" | "edit" | "review"

export const modalTexts: Record<
  ReferralModalMode,
  { title: string; subtitle: string; info?: React.ReactNode; confirm: string }
> = {
  add: {
    title: "Add a referral",
    subtitle: "Place free thermostats at client properties. We handle orders and installs.",
    info: (
      <>
        Referrals you add start as <strong>Submitted</strong>. A specialist verifies the sale, then assigns a local
        contractor and ships the units.
      </>
    ),
    confirm: "Submit referral",
  },
  edit: {
    title: "Edit referral",
    subtitle: "Update the referral details.",
    confirm: "Save changes",
  },
  review: {
    title: "Review referral",
    subtitle: "Review and confirm the referral. Fix any highlighted fields to continue.",
    info: "This referral was saved as incomplete. Complete the missing fields and submit to continue processing.",
    confirm: "Submit referral",
  },
}
